import React from 'react';

export default function SignModule({ isFor, formUpdated, formState, disabled }) {
  return (
    <div className="sign-module">
      <label disabled={disabled} className="sign-label" htmlFor={isFor}>{isFor.replace(/^./, isFor[0].toUpperCase())}</label>
      <input disabled={disabled} className="sign-input" required name={isFor} onChange={formUpdated} value={formState[isFor]} type={isFor} />
    </div>
  )
}
